<template>
  <v-form ref="cashiersForm">
    <v-row>
      <v-col cols="12" md="12">
        <p class="text-h6">Información general</p>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-autocomplete
          v-model="dataForm.clnt"
          :rules="rules.cliente"
          outlined
          dense
          label="Cliente"
          item-value="Id"
          item-text="text"
          :items="comp_clients"
        ></v-autocomplete>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-select
          v-model="dataForm.dpto"
          :rules="rules.dpto"
          outlined
          dense
          label="Departamento"
          item-value="id"
          item-text="text"
          :items="departamentos"
        ></v-select>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-select
          v-model="dataForm.tip"
          :rules="rules.tip"
          outlined
          dense
          label="Tipo"
          item-value="id"
          item-text="nam"
          :items="getTiposCredito"
        ></v-select>
      </v-col>
      <v-col class="mt-n7" cols="12" md="12">
        <v-text-field
          v-model="dataForm.lcdt"
          :rules="rules.lcdt"
          type="number"
          label="Limite de Crédito"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col class="mt-n7" cols="12" md="12">
        <v-text-field
          v-if="tipo.coi == 'FIN'"
          v-model="dataForm.npgo"
          :rules="rules.npgo"
          type="number"
          label="Numero de pagos (Meses)"
          outlined
          dense
          required
        >
          <v-btn
            @click="showTable()"
            elevation="0"
            dark
            small
            slot="append"
            color="primary"
          >
            Plan de pagos
          </v-btn>
        </v-text-field>
      </v-col>
      <v-col class="mt-n7" cols="12" md="12">
        <v-text-field
          type="number"
          v-model="dataForm.tia"
          :rules="rules.tia"
          label="Tasa de interes anual (%)"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col class="mt-n7" cols="12" md="12">
        <v-text-field
          v-model="dataForm.dcte"
          :rules="rules.corte"
          type="number"
          label="Día de corte"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col class="mt-n7" cols="12" md="12">
        <v-text-field
          v-model="dataForm.dpgo"
          type="number"
          label="Día limite pago"
          :rules="rules.diaLimitePago"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <TablaPlanPagos
      v-if="(tipo.coi == 'FIN') & (showPlanPagos == true)"
      :FinancialMode="true"
      :periodos="dataForm.npgo"
      :montoInicial="dataForm.lcdt"
      :tia="dataForm.tia"
    />
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import Cliente from "../../clases/Cliente.js";
import TablaPlanPagos from "../MainComponents/Membresias/TablaPlanPagos.vue";
import { mapGetters } from "vuex";
export default {
  name: "CreditoForm",
  components: { TablaPlanPagos },
  props: ["edit", "dataEdit", "preloadData", "modeActionFinancial"],
  data() {
    return {
      tipos: [
        { id: "REV", text: "REVOLVENTE" },
        { id: "FIN", text: "FINANCIAMIENTO" },
        { id: "CON", text: "CONCEPTOS" },
      ],
      departamentos: [{ id: "DEFAULT", text: "GENERAL" }],
      showPlanPagos: false,
      dataForm: {
        clnt: "",
        Descripcion: "",
        lcdt: "",
        tia: "",
        tip: "REV",
        ncdt: null,
        npgo: 1,
        dcte: "",
        dpgo: "",
        dpto: "",
      },
      rules: {
        tia: [(value) => !!value || "El Tasa de interés anual es obligatorio"],
        dpto: [(value) => !!value || "El departamento es obligatorio"],
        lcdt: [(value) => !!value || "El limite de crédito es obligatorio"],
        tip: [(value) => !!value || "El tipo de crédito es obligatorio"],
        cliente: [(value) => !!value || "El cliente es obligatorio"],
        corte: [
          (value) =>
            (value >= 1 && value <= 15) ||
            "El dia de corte debe estar entre 1 y 15",
        ],
        diaLimitePago: [
          (value) =>
            (value >= 1 && value <= 30) ||
            "El dia de corte debe estar entre 1 y 30",
        ],
      },
    };
  },
  computed: {
    ...mapGetters("LineasCredito", ["getTiposCredito"]),
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });
      clientes.forEach((cli) => {
        cli.value = cli.Id;
        cli.text = cli.getNombreCompleto();
      });
      return clientes;
    },
    tipo() {
      let tipo = this.$pgsHelper.getById(
        this.getTiposCredito,
        "id",
        this.dataForm.tip
      );
      return tipo;
    },
  },
  methods: {
    showTable() {
      this.showPlanPagos = !this.showPlanPagos;
    },
    async getDepartamentosBnk() {
      const database = this.$store.getters.getFirebaseApp.database;
      let snapshot = await database.queryBuilder("BNK/Departamentos", []);
      if (snapshot.exists()) {
        let dep = Object.entries(snapshot.val());
        this.departamentos = [];
        dep.forEach((el) => {
          this.departamentos.push({ id: el[0], text: el[1].Nombre });
        });
      }
    },
    checkForm() {
      if (this.$refs.cashiersForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        if (this.modeActionFinancial) {
          doAction = "FINACCION";
        }
        this.send(doAction);
      }
    },
    send(action) {
      let dataSave = this.dataForm;
      dataSave.dcte = Number(dataSave.dcte);
      dataSave.dpgo = Number(dataSave.dpgo);
      dataSave.tia = Number(dataSave.tia);
      dataSave.lcdt = Number(dataSave.lcdt);
      if (this.tipo.coi != "FIN") {
        dataSave.npgo = null;
      } else {
        dataSave.npgo = Number(dataSave.npgo);
      }
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }
      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    this.$store.dispatch("LineasCredito/getTiposCredito");

    if (this.edit) {
      this.dataForm = this.dataEdit;
    }
    if (this.preloadData) {
      this.dataForm.tip = this.preloadData.tipo;
      this.dataForm.clnt = this.preloadData.cliente;
      this.dataForm.lcdt = this.preloadData.cantidad;
    }
    this.getDepartamentosBnk();
  },
};
</script>
